import React, { Fragment, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import ReactSVG from 'react-svg';
import cx from "classnames";
import Loader from '../Loader';

import './styles.scss';

// const DEFAULT_TABS_WIDTH = "width-500";

const Tabs = (props) => {
    const {
        t,
        config,
        history,
        watchParam,
        activeTab,
        setActiveTab,
        className,
        isCollapsed,
        onToggleTabs,
        withoutHistory,
        // tripleCollapse
        tabsCollapseState,
        isLoading,
        onCountChange = () => {}
    } = props;

    // const [tabsWidth, setTabsWidth] = useState(() => {
    //     return localStorage.getItem(tripleCollapse) || DEFAULT_TABS_WIDTH;
    // });
    
    const currentTab = activeTab || props.match.params[watchParam];
    const { url } = props.match;
    const handleTabClick = (tab) => {
        if (currentTab !== tab) {
            if (setActiveTab) {
                return setActiveTab(tab);
            }
            if (!withoutHistory) {
                history.push(url.replace(currentTab, tab));
            }
        }
    };

    const renderTabs = (conf, index) => {
        const { tab, permission, translateName, icon, counting, countTotal, availabilityOfNew } = conf;
        if (!permission) return;
        const isActive = tab.toLowerCase() === currentTab && currentTab.toLowerCase();

        const nextTab = config[index + 1];
        let isNextActive = false;
        if (nextTab && nextTab.tab.toLowerCase() === currentTab && currentTab.toLowerCase()) {
            isNextActive = true;
        }
        const counter = counting && countTotal ? (
            <span className={cx("tab-counter", { availabilityOfNew })}><span className="tab-count">{countTotal}</span></span>
        ) : null;
        return (
            <div
                className={cx("tab-item", {
                    active: isActive,
                    "is-next-active": isNextActive,
                })}
                key={tab}
                title={t(translateName)}
                onClick={() => handleTabClick(tab)}
            >
                <div className='tab-item-content'>
                    {icon && (
                        <div className={cx("tab-svg-wrapper", { "with-counter": counter })}>
                            <ReactSVG
                                svgClassName="tab-svg"
                                src={`/data/svg/${icon}.svg`}
                            />
                            {counter}
                        </div>
                    )}
                    <span>{t(translateName)}</span>
                </div>
            </div>
        );
    };

    const TabContent = currentTab ? (config.filter(tab => tab.tab === currentTab)[0] || {}).component : null;

    // const iconHandler = () => {
    //     let newTabsWidth = DEFAULT_TABS_WIDTH;
    //     if (tabsWidth === DEFAULT_TABS_WIDTH) {
    //         newTabsWidth = "width-450";
    //     }
    //     if (tabsWidth === "width-450") {
    //         newTabsWidth = "width-0";
    //     }
    //     setTabsWidth(newTabsWidth);
    //     localStorage.setItem(tripleCollapse, newTabsWidth);
    //     if (props.setTabsWidth && typeof props.setTabsWidth === 'function') {
    //         props.setTabsWidth(newTabsWidth);
    //     }
    // };

    // useEffect(() => {
    //     localStorage.setItem(tripleCollapse, tabsWidth);
    //     if (props.setTabsWidth && typeof props.setTabsWidth === 'function') {
    //         props.setTabsWidth(tabsWidth);
    //     }
    //     console.log("tabsWidth", tripleCollapse + " " + tabsWidth);
    // }, [tabsWidth, props.setTabsWidth]);

    return (
        <div className={className || 'subtabs-panel ' + tabsCollapseState}>
            <div className='tabs'>
                <div className="tab-nav">
                    {config.map(renderTabs)}
                </div>

                {onToggleTabs && (
                    <div className="tab-header-buttons">
                        <div className="button-hover-half-circle" onClick={onToggleTabs}>
                            <ReactSVG className="button-icon button-icon-size" src={`/data/svg/tab-right-${tabsCollapseState}.svg`} />
                        </div>
                    </div>
                )} 
                {tabsCollapseState !== "layout-collapse-collapsed" && TabContent && (
                    <TabContent {...props} onCountChange={countToal => onCountChange(countToal, currentTab)} />
                )}
                {tabsCollapseState !== "layout-collapse-collapsed" && isLoading && <Loader />}
            </div>
        </div>
    );
};

export default withTranslation()(withRouter(Tabs));
